import type { GPEventResponse, GamePageResponse, GamePageLazyResponse } from "../../../../../../../frontend/portal/src/libs/apiClient";
import { calculateFootballTimeStamp, handlePlayEvent } from "../../../functions";
import { EventTypes } from "../../../types";
import { TimelineHalf } from "./TimelineHalf";
import "./timeline.css"
import { _ } from "i18n";
import { useImageSrcWithFallback } from "../../../../hooks/useImageSrcWithFallback";
import { useContext, useRef } from "react";
import { Link } from "react-router";
import { useVideoPlayer } from "../../../Contexts/contexts";
import clubPlaceholder from "ui-kit/assets/images/logo_fixtures.png"

interface TimelineProps {
    gameData: GamePageResponse;
    gameDataLazy?: GamePageLazyResponse;
}

export function Timeline({ gameData, gameDataLazy }: TimelineProps) {
    const { playerRef } = useVideoPlayer();
    const containerRef = useRef<HTMLDivElement>(null);

    const enabledEventTypes = [EventTypes.Goal, EventTypes.GoalOwn, EventTypes.Substitution, EventTypes.Card]

    const timelineEvents = (gameDataLazy?.events || []).filter((event) => {
        return enabledEventTypes.includes(event.type as EventTypes);
    })

    const getHalfEvents = (halfId: number) => {
        return timelineEvents.filter((event) => event.half === halfId)
    }

    const handleGetTimestamp = (event: GPEventResponse) => {
        if (gameData.halves) {
            return calculateFootballTimeStamp(event, gameData.halves)
        }
    }

    const { imgSrc: timelineHomeLogoSrc, onImgError: onTimelineHomeLogoError } = useImageSrcWithFallback({
        sourceKey: gameData.homeGameTeam.club?.logo ?? null,
        fallbackSrc: clubPlaceholder,
    });
    const { imgSrc: timelineAwayLogoSrc, onImgError: onTimelineAwayLogoError } = useImageSrcWithFallback({
        sourceKey: gameData.awayGameTeam.logo ?? null,
        fallbackSrc: clubPlaceholder,
    });

    return (
        <div className="timeline-container">
            <div className="timelineHeader-container">
                <div className="clubName">
                    {gameData.homeGameTeam?.url
                        ?
                        <Link target={"_blank"} to={gameData.homeGameTeam?.url}>
                            <img className="time-line-logo" alt="homeTeam" src={timelineHomeLogoSrc ?? clubPlaceholder} onError={onTimelineHomeLogoError} />
                        </Link>
                        :
                        <img className="time-line-logo" alt="homeTeam" src={timelineHomeLogoSrc ?? clubPlaceholder} onError={onTimelineHomeLogoError} />
                    }
                    <div className="nameText">{gameData.homeGameTeam.clubName}</div>
                </div>
                <div className="clubName">
                    <div className="nameText">{gameData.awayGameTeam.clubName}</div>
                    {gameData.awayGameTeam?.url
                        ?
                        <Link target={"_blank"} to={gameData.awayGameTeam?.url}>
                            <img className="time-line-logo" alt="homeTeam" src={timelineAwayLogoSrc ?? clubPlaceholder} onError={onTimelineAwayLogoError} />
                        </Link>
                        :
                        <img className="time-line-logo" alt="homeTeam" src={timelineAwayLogoSrc ?? clubPlaceholder} onError={onTimelineAwayLogoError} />
                    }
                </div>
            </div>
            <div className="timelineBottom" ref={containerRef}>
                {gameData.halves?.map((half) =>
                    <TimelineHalf
                        key={half.id}
                        containerRef={containerRef}
                        half={half}
                        events={getHalfEvents(half.id)}
                        homeTeamId={gameData.homeGameTeam.id}
                        handleGetTimestamp={handleGetTimestamp}
                    />
                )}
                <div className="matchHalfTimestamp" onClick={() => handlePlayEvent(playerRef, gameData.halves?.[gameData.halves.length - 1].videoTimeEnd)}>
                    <span className="icon-new icon-whistle icon-16" />
                    {_("timeline.label.matchEnd")}
                </div>
            </div>
        </div>
    )
}
